import gql from 'graphql-tag';

export const QUERY_PAYMENT_PLANS = gql`
  query queryPaymentPlans(
    $currency: String
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
    $category: PaymentPlanCategory
  ) {
    paymentPlans(
      currency: $currency
      pageSize: $pageSize
      pageNumber: $pageNumber
      category: $category
    ) {
      edges {
        node {
          hasIntegratedProperty
          paymentOnline
          category
          active
          id
          name
          currency
          description
          deposits {
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
            createdAt
          }
          fees {
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
            createdAt
          }
          instalments {
            createdAt
            fromTenancy
            id
            payMonthly
            payQuarterly
            payWeekly
            payRemainderAtOnce
            fullPayment
            name
            paymentPlanId
            requireGuarantor
            tenancyUnit
            toTenancy
            payNowAmount
            updatedAt
            country {
              name
            }
          }
          properties {
            id
            name
            slug
            status
          }
          startDate
          endDate
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      totalCount
    }
  }
`;

export const UPDATE_PROPERTY_PAYMENT_PLAN = gql`
  mutation updatePropertyPaymentPlan($input: UpdatePropertyPaymentPlanInput!) {
    updatePropertyPaymentPlan(input: $input) {
      success
    }
  }
`;
